module.exports = __webpack_public_path__ + "static/media/en-cancel-package_5.afe5c3ac.png";